export interface SystemSettings {
  id?: string;
  pin: string;
  mainNotificationRecipient: string;
  additionalNotificationsRecipients: string[];
  securityInfoRecipients: string[] | null;
  selfRegistrationActive: boolean;
  promotionalBannerMessage: string;
  promotionalBannerIsActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export type ModulesConfiguration = {
  [key in MODULE_KEY]?: boolean;
};

export enum MODULE_KEY {
  CVM = 'CVM',
  RESIDENCE_PERMIT = 'RESIDENCE_PERMIT',
  WORK_PERMIT = 'WORK_PERMIT',
  TASKS = 'TASKS',
  TRACKING = 'TRACKING',
  OTHER = 'OTHER',
}
